import { isLoadMinHeaderWebp } from './common';
const preloadElementImageOjbcet = {
  seaDig: {
    en: [new URL('@/assets/seaDig/bg.png', import.meta.url).href],
    ar: [new URL('@/assets/seaDig/ar-bg.png', import.meta.url).href],
    tr: [new URL('@/assets/seaDig/tr-bg.png', import.meta.url).href],
  },
};
// 根据不同的活动预加载不同的头图资源或者页面首屏最大渲染元素图片
export const preloadElementImage = async () => {
  try {
    let lang: string = sessionStorage.getItem('language') || 'en';
    if (lang !== 'ar' && lang !== 'en' && lang !== 'in' && lang !== 'pt') lang = 'en';
    const isWebp = await isLoadMinHeaderWebp();
    const path = window.location.hash.split('#/')[1];
    if (!path) return;
    const langImage = preloadElementImageOjbcet[path as keyof typeof preloadElementImageOjbcet];
    let perloadList = langImage[lang as keyof typeof langImage];
    if (!perloadList) return;
    if (isWebp) {
      const newUrl = perloadList.filter((item) => item.split('?')[0].split('.')[item.split('.').length - 1] === 'webp');
      perloadList.forEach((item) => {
        let itemSir = '';
        item.split('.').forEach((itemG, index) => {
          if (index !== item.split('.').length - 1) {
            itemSir += itemG;
          }
        });
        if ((newUrl.indexOf(itemSir) < 0)) {
          newUrl.push(item);
        }
      });
      perloadList = newUrl;
    } else {
      const newUrl = perloadList.filter((item) => item.split('.')[item.split('.').length - 1] !== 'webp');
      perloadList = newUrl;
    }
    window.requestAnimationFrame(() => {
      const headDom = document.querySelector('head');
      if (!headDom) return;
      perloadList.forEach((item) => {
        const link = document.createElement('link') as HTMLLinkElement;
        link.href = item;
        link.as = 'image';
        link.rel = 'preload';
        headDom.prepend(link);
      });
    });
  } catch (error) {
    console.log('preloadElementImage:error', error);
  }
};
